import {
	Button,
	Form,
	Input,
	List,
	ListItem,
	Modal,
} from '@mairistem/composants';
import { isEmpty } from 'lodash';
import React from 'react';
import { toast } from 'react-toastify';
import type { UtilisateurCollectivite } from '../../../interfaces/utilisateurCollectivite';

interface UtilisateurDeleteModalProps {
	selectedUtilisateur: UtilisateurCollectivite;
	onClose: () => void;
	onDelete: (utilisateur: UtilisateurCollectivite) => void;
	isLoading?: boolean;
}

const UtilisateurDeleteModal = ({
	selectedUtilisateur,
	onDelete,
	onClose,
	isLoading,
}: UtilisateurDeleteModalProps) => {
	const [confirmationText, setConfirmationText] = React.useState('');

	const handleValidate = () => {
		if (isEmpty(confirmationText) || confirmationText.toUpperCase() !== 'OUI') {
			toast.error(
				"Veuillez saisir OUI pour confirmer la suppression de l'utilisateur.",
			);
			return;
		}
		onDelete(selectedUtilisateur);
	};

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setConfirmationText(e.target.value);
	};

	return (
		<Modal onClose={onClose} open>
			<Modal.Header>Confirmation de suppression</Modal.Header>
			<Modal.Content image>
				<Modal.Description>
					<p>
						Êtes-vous absolument certain de vouloir supprimer l&apos;utilisateur
						&quot;
						{selectedUtilisateur?.prenom} {selectedUtilisateur?.nom}
						&quot; ?
						<br />
						<br />
						Cette action est <strong>IRRÉVERSIBLE</strong> et supprimera
						définitivement :
						<List as="ul">
							<ListItem as="li">L&apos;accès de l&apos;utilisateur</ListItem>
							<ListItem as="li">Toutes ses associations aux bureaux</ListItem>
							<ListItem as="li">La possibilité de télétransmettre</ListItem>
						</List>
						<br />
						Veuillez saisir OUI en toutes lettres pour confirmer cette action.
						<br />
					</p>
					<Form.Field
						// @ts-expect-error
						control={Input}
						fluid
						value={confirmationText}
						onChange={handleChange}
						placeholder="Saisir OUI pour confirmer"
					/>
				</Modal.Description>
			</Modal.Content>
			<Modal.Actions>
				<Button color="black" onClick={onClose}>
					Annuler
				</Button>
				<Button
					icon="checkmark"
					onClick={handleValidate}
					primary
					loading={isLoading}
				>
					Valider
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default UtilisateurDeleteModal;
